module.exports = __webpack_public_path__ + "static/media/SS_05.72beeb05.jpg";